<template>
  <div>
    <button type="button"
            class="btn btn-icon fab-registro-incidencia"
            title="Reportar incidencia"
            aria-label="Reportar incidencia"
            @click.prevent="abrir">
      <i class="fa fa-exclamation-triangle" style="color: #fff;"></i>
    </button>
    <ficha-incidencias
      ref="incidencias"
      ocultar-lista
      instancia="fab"
      :local-votacion-mesa-proceso-electoral-id="localVotacionMesaProcesoElectoralId"
      :mesa-votacion-id="mesaVotacionId"
      :proceso-electoral-id="procesoElectoralId"
      :turno="turno"
    />
  </div>
</template>

<script>
import FichaIncidencias from "./FichaIncidencias";

export default {
  name: "FabRegistroIncidencia",
  components: { FichaIncidencias },
  props: {
    localVotacionMesaProcesoElectoralId: { type: [Number, String], default: null },
    mesaVotacionId: { type: [Number, String], required: true },
    procesoElectoralId: { type: [Number, String], required: true },
    turno: { type: Number, default: 1 },
  },
  methods: {
    abrir() {
      if (this.$refs.incidencias) this.$refs.incidencias.abrir(null);
    },
  },
};
</script>

<style scoped>
.fab-registro-incidencia {
  position: fixed;
  right: 24px;
  bottom: 88px;
  z-index: 110;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #e71c1c;
  color: #fff;
  border: 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.28);
}
.fab-registro-incidencia:hover,
.fab-registro-incidencia:focus {
  background: #c41616;
  color: #fff;
}
.fab-registro-incidencia i {
  font-size: 1.35rem;
}
</style>
